export const StiftungChance = ({ label = "Stiftung Chance", testid = "stiftung-chance-link", className = "" }) => (
  <a
    href="https://www.stiftung-chance.ch"
    target="_blank"
    rel="noopener noreferrer"
    className={`underline decoration-magenta/40 underline-offset-2 transition-colors duration-300 hover:text-magenta hover:decoration-magenta ${className}`}
    data-testid={testid}
  >
    {label}
  </a>
);
